export const viemaxImgUrls = {
  logo: require('../assets/images/logos/viemax-logo.webp'),
  logoWhite: require('../assets/images/logos/viemax-white-logo.png'),
  playIcon: require('../assets/icons/play-circle.png'),
  heroSection: require('../assets/images/programs/viemax-program/hero-section.webp'),
  faqs: {
    chevronUp: require('../assets/images/programs/viemax-program/chevron-up.png'),
    chevronDown: require('../assets/images/programs/viemax-program/chevron-down.png'),
  },

  offerings: {
    freeNutriConsult: require('../assets/images/programs/viemax-program/offerings/free-nutri-consult.webp'),
    exclusiveDiscounts: require('../assets/images/programs/viemax-program/offerings/exclusive-discunts.webp'),
    curatedEducationalContent: require('../assets/images/programs/viemax-program/offerings/curated-educational-content.webp'),
  },
  highlights: {
    designedByNutritionExperts: require('../assets/images/expertise.png'),
    trustedByCustomers: require('../assets/images/trusted.png'),
  },
  ourStories: {
    bottomWhiteBg: require('../assets/images/programs/viemax-program/bottom-white-bg.png'),
    thumbnail: require('../assets/images/programs/viemax-program/stories-thumbnail.webp'),
    title: 'Struggling with Sugar Levels? Manage Diabetes with GoodFlip!',
    videoUrl:
      'https://www.youtube.com/embed/XD4L2Vq7HQQ?list=PLpa6Divno66YWrmcLWwbh8Zmt4W_6P4rU',
  },
  recoveryJourney: require('../assets/images/programs/viemax-program/recovery-journey.webp'),

  notPurchased: {
    howToClaim: require('../assets/images/programs/viemax-program/how-to-claim.webp'),
    whatToExpect: require('../assets/images/programs/viemax-program/what-to-expect.webp'),
  },
  verifyCodeDemo: require('../assets/images/programs/viemax-program/verify-code-demo.webp'),
  successImageWithWoman: require('../assets/images/programs/viemax-program/success-program-image.webp'),
  profuctImage: require('../assets/images/programs/viemax-program/product-image.webp'),
  profuctImageWithBg: require('../assets/images/programs/viemax-program/product-image-with-bg.webp'),
  planExpiredImage: require('../assets/images/programs/viemax-program/plan-expired-locked.webp'),
  wavyBorder: require('../assets/images/programs/viemax-program/wavy-border.png'),
}

//  Get Viemax Care Program for free with every purchase
export const offeringSection = {
  offerings: [
    {
      title: 'Free Nutritionist Consultation',
      desc: 'Expert advice to help you achieve your health goals',
      image: viemaxImgUrls.offerings.freeNutriConsult,
    },
    {
      title: 'Exclusive Discounts',
      desc: 'Enjoy extra savings on diagnostic bookings',
      image: viemaxImgUrls.offerings.exclusiveDiscounts,
    },
    {
      title: 'Curated Educational Content',
      desc: 'Access personalized resources to support your wellness journey',
      image: viemaxImgUrls.offerings.curatedEducationalContent,
    },
  ],
}

export const highlightsSection = {
  highlights: [
    {
      title: 'Designed by Nutrition Experts',
      desc: '',
      image: viemaxImgUrls.highlights.designedByNutritionExperts,
    },
    {
      title: 'Trusted by 10,000+ customers',
      desc: '',
      image: viemaxImgUrls.highlights.trustedByCustomers,
    },
  ],
}

export const faqs = [
  {
    title: 'How do I access the Viemax Care Program?',
    answer:
      'Scan the QR code inside your Viemax pack to download the app and activate the program.',
  },
  {
    title: 'What benefits do I get with the Viemax Care Program?',
    answer:
      'With the Viemax Care Program, you get a free nutritionist consultation, discounts on diagnostics and smart health devices, and access to curated health guides.',
  },
  {
    title: 'How long do the benefits last?',
    answer:
      'The benefits last for 1 month with the 400g pack of Viemax and 15 days with the 200g pack. You can renew your benefits with every new Viemax purchase.',
  },
  {
    title: 'Is my information secure?',
    answer:
      'Yes, your information is completely secure. Protecting your privacy and data is our top priority, and we follow strict safety protocols to keep it safe.',
  },
]
export const verifyCodeRegex = /^[A-Za-z0-9]{6,8}$/
export const maxCodeLength = 8
export const minCodeLength = 6
export const verifyCodeErrorMessage = 'Invalid code'
export const minDaysToExtendPlan = 7
export const shopifyBcaUrl =
  'https://shop.goodflip.in/products/goodflip-smart-body-composition-analyser'

// Zy-plan-expired is disabled for now as per the client request,
// To Enable it, set showExtendPlan to true
export const showExtendPlan = false
